import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { KustoDatabaseLinkedService } from '../linkedservice/kusto-database.linkedservice';
import { AzureDataExplorerDataset } from './azure-data-explorer.dataset';
import { IModel } from '../base/annotation';

@Metamodel.model({
    name: ModelConstants.kustoDatabaseDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.KustoDatabase_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.KustoDatabase_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: KustoDatabaseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class KustoDatabaseDataset extends AzureDataExplorerDataset {
    public static readonly MODEL: IModel;
}
